import axios from "axios";
import API from "./API.js";
import { serialize } from "object-to-formdata";

export default class Activities extends API {
  static STUDENT = {};
  static ACTIVITY = {};
  constructor() {
    super("activities");
  }

  //updateTeacher
  async updateTeacher(data, headers = {}) {
    let { id } = data;
    if (!data.id) {
      id = data.get("id");
      data.append("_method", "PUT");
    }
    try {
      // alert(this.route);
      // console.log(data);
      const response = await axios.post(`/${this.route}/${id}`, data, headers);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload
      }
    }
  }
  async forum_answers(params) {
    try {
      const response = await axios.get("forum_answers", { params });
      return response.data;
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload
      }
    }
  }
  async update_answer(data, headers = {}) {
    data = serialize(data, {
      indices: true,
      nullsAsUndefineds: false,
      booleansAsIntegers: false,
      allowEmptyArrays: true,
    });
    try {
      const response = await axios.post("update_user_answer", data, headers);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload
      }
    }
  }
  async insert_answer(data, headers = {}) {
    data = serialize(data, {
      indices: true,
      nullsAsUndefineds: false,
      booleansAsIntegers: false,
      allowEmptyArrays: true,
    });
    try {
      const response = await axios.post("save_user_answer", data, headers);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload
      }
    }
  }

  async GetHomeWorkAnswers(params) {
    try {
      const response = await axios.get("answers_data_Table", { params });
      let { data } = response;
      if (params) data = response.data.data;
      if (this.imageFileds) this.addImagePath(data, this.imageFileds);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload
      }
    }
  }
  async studentsDataTable(params) {
    try {
      const response = await axios.get("/students_dataTable", { params });
      let { data } = response;
      if (params) data = response.data.data;
      return response.data;
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload
      }
    }
  }
  async teacherCourses(params) {
    try {
      const response = await axios.get("teacher_courses", { params });
      let { data } = response;
      if (params) data = response.data.data;
      return response.data;
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload
      }
    }
  }
  async teacherCoursesNew(params) {
    try {
      const response = await axios.get("teacher_courses_new", { params });
      let { data } = response;
      if (params) data = response.data.data;
      return response.data;
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload
      }
    }
  }
  async getStudentActivities(params) {
    try {
      const response = await axios.get("getStudentActivities", { params });
      let { data } = response;
      if (params) data = response.data.data;
      return response.data;
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload
      }
    }
  }
  async getCourseActivitesDate(params) {
    try {
      const response = await axios.get("getCourseActivitiesDate", { params });
      let { data } = response;
      if (params) data = response.data.data;
      return response.data;
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload
      }
    }
  }
  async correct_activity(data, headers = {}) {
    try {
      const response = await axios.post("correct_activity", data, headers);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload
      }
    }
  }
  async updateDates(data, headers = {}) {
    try {
      const response = await axios.post("updateActivitiesDates", data, headers);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload
      }
    }
  }
  //new
  async addActivityNew(data) {
    try {
      const response = await axios.post("activities/addActivitiesNew", data);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload
      }
    }
  }

  async editActivityNew(data){
    try {
      const response = await axios.patch("activities/editActivitiesNew/"+data.id, data);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload
      }
    }
  }

  async getAllNew(params) {
    try {
      const response = await axios.get(`/activities_new`, { params });
      let { data } = response;
      if (params) data = response.data.data;
      return response.data;
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload
      }
    }
  }

  async DeleteNew(id, recordIds = []){
    try {
      const response = await axios.delete(`/activities_new/${id}`, {
        data: { recordIds },
      })
      return response.data
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload 
      }
    }
  }

  async uploadHomeWork(data){
    const response = await axios.post('/activities_new/upload_homework',data);
    return response;
  }

  async uploadForum(data){
    const response = await axios.post('/activities_new/upload_forum',data);
    return response;
  }

  async uploadQuiz(data){
    const response = await axios.post('/activities_new/upload_quiz',data);
    return response;
  }

  async editHomeWork(data){
    const response = await axios.post('/activities_new/edit_homework',data);
    return response;
  }

  async editForum(data){
    const response = await axios.post('/activities_new/edit_forum',data);
    return response;
  }

  async editQuiz(data){
    const response = await axios.post('/activities_new/edit_quiz',data);
    return response;
  }

  async getActivityForStudent(id){
    try {
      const response = await axios.get(`/activites_new/get_activity_for_student/${id}`);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload
      }
    }
  }

  async getActivityAttempt(activityId, studentId){
    try {
      const response = await axios.get(`/activites_new/get_activity_attempt/${activityId}/${studentId}`);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload
      }
    }
  }

  async getActivityForStudentExam(id){
    try {
      const response = await axios.get(`/activites_new/get_activity_for_student_exam/${id}`);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload
      }
    }
  }

  async submitActivityForStudent(data, headers = {}){
    try {
      const response = await axios.post('/activites_new/submit_activity_for_student', data, headers);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload
      }
      throw error;
    }
  }

  
}
